export const setAllTransCdata = (transcriptionData) =>
	({
		type    : 'SET_ALL_TRANSCRIPTIONDATA',
		payload : { transcriptionData }
	});

export const setEachTransCdata = (eachTranscription) =>
	({
		type    : 'SET_EACH_TRANSCRIPTIONDATA',
		payload : { eachTranscription }
	});

export const setSkip = (skip) =>
	({
		type    : 'SET_SKIP',
		payload : { skip }
	});
export const setRefreshData = (refreshTranscriptionData) =>
	({
		type    : 'SET_REFRESH_DATA',
		payload : { refreshTranscriptionData }
	});
export const setTranscriptionOptions = (transcriptionOptions) =>
	({
		type    : 'SET_TRANSCRIPTION_OPTIONS',
		payload : { transcriptionOptions }
	});
export const setFinaltext = (finalText) =>
	({
		type    : 'SET_FINAL_TEXT',
		payload : finalText
	});
export const removeFinalText = (finalText) =>
	({
		type    : 'REMOVE_FINAL_TEXT',
		payload : finalText
	});